// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3vHcJ","overflowing":"ReadFullNote_overflowing__3ePTr"};